import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import PricingTiers from "./sections/PricingTiers";
import PackageDetails from "./sections/PackageDetails";
import RequestACustomQuote from "./sections/RequestACustomQuote";
import CustomQuoteForm from "./sections/CustomQuoteForm";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <PricingTiers />
      <PackageDetails />
      <CustomQuoteForm />
      <RequestACustomQuote />
      <Footer />
    </div>;
}